import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, Observable } from 'rxjs';
import { LocalStorageService } from '../services/local-storage.service';

@Injectable({ providedIn: 'root' })
export class SecurityInterceptor implements HttpInterceptor {
  constructor(private localStorageService: LocalStorageService, private router: Router) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.includes('https://artico-dev-file-repository.s3.us-west-2.amazonaws.com'))
      return next.handle(req);

    const token = this.localStorageService.get('sessionToken');
    let request = req;

    if (token) request = req.clone({ setHeaders: { Authorization: `Bearer ${token}` } });

    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.status === 403) {
          this.localStorageService.remove('sessionToken');
          this.router.navigateByUrl('/login');
        }

        throw new Error(err.message);
      })
    );
  }
}
